import { Link } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { formatSubscriptionExpiry } from "../utils/userProfile";

export const ONBOARDING_STEPS = [  {
    id: "subscription",
    title: "Оформите подписку",
    desc: "Выберите тариф по размеру команды.",
    link: "/main/price",
    linkLabel: "Тарифы",
  },
  {
    id: "publish",
    title: "Опубликуйте сценарий",
    desc: "Подготовьте программу и включите публикацию в настройках.",
    link: null,
    linkLabel: null,
  },
  {
    id: "share",
    title: "Разошлите ссылку сотрудникам",
    desc: "В настройках проекта выберите мессенджеры и скопируйте ссылку для команды.",
    link: null,
    linkLabel: null,
  },
];

export function getOnboardingProgress(businessSubscription, games) {
  const safeGames = Array.isArray(games) ? games : [];
  const hasSubscription = Boolean(formatSubscriptionExpiry(businessSubscription));
  const hasPublished = safeGames.some((game) => game?.settings?.published);
  const hasShareReady = safeGames.some(
    (game) => game?.settings?.published && game?.settings?.private_access === false
  );

  const completed = {
    subscription: hasSubscription,
    publish: hasPublished,
    share: hasShareReady,
  };

  const doneCount = Object.values(completed).filter(Boolean).length;
  const total = ONBOARDING_STEPS.length;

  return {
    completed,
    doneCount,
    total,
    allDone: doneCount === total,
  };
}

export default function OnboardingChecklist({
  businessSubscription,
  games,
  showHeader = true,
  className = "",
}) {
  const { completed, doneCount, total, allDone } = getOnboardingProgress(    businessSubscription,
    games
  );

  if (allDone) return null;

  return (
    <section
      className={`app-onboarding${showHeader ? "" : " app-onboarding--embedded"}${className ? ` ${className}` : ""}`}
    >
      {showHeader ? (
        <div className="app-onboarding__head">
          <h2 className="app-onboarding__title">Запуск обучения для команды</h2>
          <span className="app-onboarding__progress">
            {doneCount}/{total}
          </span>
        </div>
      ) : null}
      <ol className="app-onboarding__list">        {ONBOARDING_STEPS.map((step, index) => {
          const isDone = completed[step.id];
          const Icon = isDone ? CheckCircleOutlineIcon : RadioButtonUncheckedIcon;

          return (
            <li
              key={step.id}
              className={`app-onboarding__item${
                isDone ? " app-onboarding__item--done" : ""
              }`}
            >
              <Icon className="app-onboarding__icon" fontSize="small" />
              <div className="app-onboarding__content">
                <strong>
                  Шаг {index + 1}. {step.title}
                </strong>
                <p>{step.desc}</p>
                {step.link && !isDone ? (
                  <Link to={step.link} className="app-onboarding__link">
                    {step.linkLabel}
                  </Link>
                ) : null}
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
